if (!customElements.get('most-popular-rail')) {
  customElements.define('most-popular-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-popular-track]');
      this.media = this.querySelector('.most-popular-card__media');
      this.buttons = [...this.querySelectorAll('[data-popular-direction]')];
      if (!this.track) return;

      // Keep an incomplete final desktop page from pulling in earlier products.
      const emptySlots = (4 - this.track.children.length % 4) % 4;
      this.track.style.setProperty('--popular-end-space', `${emptySlots * 25}%`);

      this.handleScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateNavigation();
        });
      };
      this.handleClick = (event) => {
        const button = event.target.closest('[data-popular-direction]');
        if (!button || button.disabled || !this.contains(button)) return;
        if (window.matchMedia('(min-width: 1001px)').matches) {
          const pageWidth = this.track.getBoundingClientRect().width;
          if (!pageWidth) return;
          const currentPage = Math.round(this.track.scrollLeft / pageWidth);
          const lastPage = Math.max(0, Math.ceil(this.track.children.length / 4) - 1);
          const nextPage = Math.max(0, Math.min(currentPage + Number(button.dataset.popularDirection), lastPage));
          this.track.scrollTo({
            left: nextPage * pageWidth,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
          return;
        }
        this.track.scrollBy({
          left: Number(button.dataset.popularDirection) * this.track.clientWidth * 0.78,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleScroll);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.track);
        if (this.media) this.resizeObserver.observe(this.media);
        [...this.track.children].forEach(item => this.resizeObserver.observe(item));
      }
      this.updateNavigation();
    }

    updateNavigation() {
      const { clientWidth, scrollWidth, scrollLeft } = this.track;
      const maxScroll = Math.max(0, scrollWidth - clientWidth);
      const position = Math.max(0, Math.min(scrollLeft, maxScroll));
      if (this.media) {
        this.style.setProperty('--popular-navigation-top', `${this.media.getBoundingClientRect().height / 2}px`);
      }
      this.buttons.forEach(button => {
        button.disabled = maxScroll <= 1 || (Number(button.dataset.popularDirection) < 0
          ? position <= 1
          : position >= maxScroll - 1);
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('resize', this.handleScroll);
      this.resizeObserver?.disconnect();
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
  });
}
